import { convertISODateOnly } from "@entrilia/shared/utilities/dateUtils";
import type { ActivityLogRecord, SearchActivityLogsRequest } from "../../../../../api/types/activityLogTypes";
import type { FilterState } from "../../../../common/filters/filterState";
import type { DateFilter, TableFilter, TableFilterDefinition } from "../../../../common/filters/filterTypes";

export interface ActivityLogViewPagingState {
  totalPages: number | undefined;
  totalItems: number | undefined;
  rowsPerPage: number;
  pageIndex: number;
}

export const getInitialActivityLogViewPagingState = (): ActivityLogViewPagingState => ({
  totalPages: undefined,
  totalItems: undefined,
  rowsPerPage: 100,
  pageIndex: 0,
});

export const activityLogFilterDefinitions: TableFilterDefinition<ActivityLogRecord>[] = [
  {
    id: "date",
    name: "Date",
    type: "date",
    operatorOptions: ["range"],
  },
];

export const getActivityLogsFilterPayload = (
  filterState: FilterState<ActivityLogRecord>
): Omit<SearchActivityLogsRequest, "paging"> => {
  const getDateRangeFilterValues = (filterId: string, visibleFilters: TableFilter<ActivityLogRecord>[]) => {
    const filter = visibleFilters.find((f) => f.id === filterId) as DateFilter<ActivityLogRecord> | undefined;
    if (filter?.value?.operator !== "range") {
      return [undefined, undefined];
    }

    const { range } = filter.value;
    const from = range?.[0];
    const to = range?.[1];
    return [from ? convertISODateOnly(from) : undefined, to ? convertISODateOnly(to) : undefined];
  };

  const [dateFrom, dateTo] = getDateRangeFilterValues("date", filterState.visibleFilters);

  return {
    dateFrom,
    dateTo,
  };
};
